import React, { useMemo, useRef } from 'react';

import { ExperienceStart } from '@atlassian/experience-tracker';

import { ExperienceNames } from '../experience-tracker/ExperienceNames';
import { StyledIframe } from '../iframe';
import { type useUrl } from './useUrl';
import { useIntl } from 'react-intl-next';

type Props = Pick<Parameters<typeof useUrl>[0], 'contentId' | 'spaceKey' | 'parentProduct'> & {
	url?: string | null;
};

export const StorageAccessPage = ({ contentId, spaceKey, url, parentProduct }: Props) => {
	const { locale } = useIntl();
	const iframeRef = useRef<HTMLIFrameElement>(null);

	const src = useMemo(() => {
		const path = `/wiki/embed/storage-access?parentProduct=${parentProduct}&locale=${locale}`;
		const origin = url ? new URL(url).origin : window.location.origin;
		return [origin, path].join('');
	}, [locale, parentProduct, url]);

	return (
		<>
			<ExperienceStart name={ExperienceNames.STORAGE_ACCESS_PAGE} id={`${spaceKey}-${contentId}`} />
			<StyledIframe data-testid="storage-access-page-iframe" src={src} ref={iframeRef} />
		</>
	);
};
